// Loaders for the off-piste / ski-touring GeoJSON produced by
// scripts/touring-routes-pipeline/. Both functions are memoized so toggling
// the layer on/off doesn't refetch.

const EMPTY_FC = Object.freeze({ type: 'FeatureCollection', features: [] });

let globalCache = null;
let globalInflight = null;
const resortCache = new Map();
const resortInflight = new Map();

async function fetchJSON(url) {
  const res = await fetch(url, { cache: 'force-cache' });
  if (!res.ok) throw new Error(`touring fetch ${url} → ${res.status}`);
  return res.json();
}

export async function loadGlobalTouringRoutes() {
  if (globalCache) return globalCache;
  if (globalInflight) return globalInflight;
  globalInflight = (async () => {
    try {
      globalCache = await fetchJSON('/data/touring-routes.geojson');
    } catch {
      globalCache = EMPTY_FC;
    }
    return globalCache;
  })();
  try { return await globalInflight; }
  finally { globalInflight = null; }
}

// Per-resort loader. On 404 (no per-resort file shipped) returns an empty
// FeatureCollection so callers don't have to special-case missing files.
export async function loadResortTouringRoutes(resortId) {
  if (resortId == null) return EMPTY_FC;
  const key = String(resortId);
  if (resortCache.has(key)) return resortCache.get(key);
  if (resortInflight.has(key)) return resortInflight.get(key);

  const inflight = (async () => {
    let fc = EMPTY_FC;
    try {
      fc = await fetchJSON(`/data/touring-routes/${encodeURIComponent(key)}.geojson`);
    } catch {
      fc = EMPTY_FC;
    }
    resortCache.set(key, fc);
    return fc;
  })();
  resortInflight.set(key, inflight);
  try { return await inflight; }
  finally { resortInflight.delete(key); }
}

export const TOURING_ATTRIBUTION_LINE =
  'Touring routes © OpenStreetMap contributors (ODbL) · Skitourenguru / swisstopo (OGD)';
